module.exports = __webpack_public_path__ + "static/media/l_dot_18.6b694905.png";